<template>
  <path d="M2 16v6h6v2H1a1 1 0 0 1-1-1v-7h2zm20-8V2h-6V0h7a1 1 0 0 1 1 1v7h-2z" fill="#000" fill-rule="nonzero"/>
</template>
